import {styled} from "@mui/material";

export const SingleSelectItemContainer = styled('div')(({theme}) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '0.5rem 1rem',
    borderRadius: '0.5rem',
    cursor: 'pointer',

    '&:hover': {
        background: theme.barekam.grey
    },
    border: `0.05rem solid ${theme.barekam.grey}`,
}));

export const SingleSelectItemSelectedContainer = styled(SingleSelectItemContainer)(({theme}) => ({
    border: `0.15rem solid ${theme.barekam.green}`,
    padding: '0.35rem 0.90rem',
}));

export const SingleSelectItemTextContainer = styled('div')(({}) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start'
}));